/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";
import { Titulo, CampoInformacion, accessAPI, tituloBase } from "../../shared";

/**
 * Integraciones externas del organismo, en solo lectura.
 *
 * Las credenciales las carga el administrador de la plataforma, no el
 * organismo, así que acá no hay nada para editar: es para saber con qué
 * servicios está conectada la plataforma y con qué parámetros.
 */
export default function Integraciones() {
  const [loader, setLoader] = useState(true);
  const [integraciones, setIntegraciones] = useState([]);
  const toast = useRef(null);

  useEffect(() => {
    document.title = "Integraciones";
    accessAPI(
      "GET",
      "admin/config/integraciones",
      null,
      (respuesta) => {
        setIntegraciones(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        setLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar las integraciones",
          sticky: true
        });
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Titulo urlVolver="/config">Integraciones</Titulo>

      {loader && (
        <div className="grid">
          <div className="col-12 lg:col-6">
            <Card>
              <Skeleton width="10rem" height="1.3rem" />
              <Skeleton width="100%" height="4rem" css={{ marginTop: "1em" }} />
            </Card>
          </div>
        </div>
      )}

      {!loader && integraciones.length === 0 && (
        <Message
          severity="info"
          css={{ width: "100%" }}
          text="Esta plataforma no tiene integraciones configuradas."
        />
      )}

      {!loader && integraciones.length > 0 && (
        <>
          <p css={{ marginTop: 0, color: "var(--grisTextos)" }}>
            Servicios externos con los que opera la plataforma. Los configura el
            administrador de Morfeo.
          </p>

          <div className="grid">
            {integraciones.map((integracion) => (
              <div key={integracion.tipo} className="col-12 lg:col-6">
                <Card>
                  <div
                    css={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.6rem",
                      marginBottom: "0.2rem"
                    }}
                  >
                    <i className={integracion.icono} />
                    <span css={{ fontWeight: 500, fontSize: "1.1rem" }}>
                      {integracion.nombre}
                    </span>
                  </div>

                  <div
                    css={{
                      color: "var(--grisTextos)",
                      marginBottom: "1rem"
                    }}
                  >
                    {integracion.descripcion}
                  </div>

                  <div className="grid">
                    {integracion.detalles.map((detalle) => (
                      <CampoInformacion
                        key={detalle.clave}
                        nombreCampo={detalle.etiqueta}
                      >
                        {detalle.valor}
                      </CampoInformacion>
                    ))}
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
